import React, { useEffect } from 'react';

export default function View() {
  useEffect(() => {
    // @ts-ignore
    if(window.opener && window.opener.___pcc_callback){
      window.opener.___pcc_callback();
      window.close();
    }
  }, [])
  return (
    <></>
  );
}
